import { useMutation, useQueryClient } from '@tanstack/react-query'

import { useUpdateCounterCache } from '@/api/models/counters/hooks/useUpdateCounterCache'
import { useSelectedProjectStore } from '@/components/entities/common/model/selected-project.store'

import { CountersService } from '..'
import { CounterValues } from '../lib/counters.service'
import { CounterData } from '../lib/counters.types'
import { COUNTERS_LIST_RQ_KEY } from './useCountersList'

type Params = {
  id: string
  values: CounterValues[]
}

export const useSendCounterValues = (
  onlyAvailable: boolean,
  counterId: string,
  newCounterValues: CounterValues[],
  premiseId?: string
) => {
  const queryClient = useQueryClient()
  const { selectedProjectId: projectId } = useSelectedProjectStore()
  const { updateCacheData } = useUpdateCounterCache(counterId, newCounterValues)

  return useMutation({
    mutationFn: ({ id, values }: Params) =>
      CountersService.sendCounterValues(id, values),
    onSuccess: async () => {
      const cancelKey = [
        COUNTERS_LIST_RQ_KEY,
        onlyAvailable,
        ...(premiseId ? [premiseId] : [])
      ]

      const queryKey = [
        COUNTERS_LIST_RQ_KEY,
        projectId,
        premiseId,
        onlyAvailable
      ]

      await queryClient.cancelQueries({ queryKey: cancelKey })

      const previousData = queryClient.getQueryData(queryKey)
      queryClient.setQueryData<{ data: CounterData[] }>(
        queryKey,
        updateCacheData
      )

      return previousData
    }
  })
}
